// src/utils/encryption.js
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

/**
 * AES transport encryption for passwords sent to the Node API.
 * Must match server `PASSWORD_ENCRYPTION_KEY`. Required — no default fallback.
 */
export const encryptPassword = (password) => {
  if (!SECRET_KEY || !String(SECRET_KEY).trim()) {
    throw new Error(
      "REACT_APP_SECRET_KEY is required for password encryption. Set it in the frontend .env and restart the app."
    );
  }
  return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
};
